module.exports = __webpack_public_path__ + "static/media/moodle.114e11b7.svg";